<template>
  <div class="search">
		<div class="breadcrumb"><a href="/">首页</a>&nbsp;&nbsp;>&nbsp;&nbsp;搜索结果</div>
		<ul class="newslist">
      <li v-for="item in searchList" :key="item.news_id" @click="details(item.news_id)">
        <div class="list_right">
					<h3>
						<span class="h3_left">{{ item.news_art_title }}</span>
						<span class="h3_right">{{ item.news_art_time.substr(0,10) }}</span>
					</h3>
          <div v-html="item.news_art_content"></div>
        </div>
      </li>
		</ul>
    <div class="page" style="margin-top:0px;margin-bottom:90px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="paginations.page_index"
        :page-sizes="paginations.page_sizes"
        :page-size="paginations.page_size"
        :layout="paginations.layout"
        :total="paginations.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
	import "@/assets/css/style.css";
	import {imgPath,cityId,keywords,description,metatitle,SiteName,SiteDomain} from "@/api/api"
	export default {
		name: "search",
		data() {
			return {
				searchList: [],
				imgPath,
				cityId,
				paginations:{
					page_index:1, //当前页
					total:0, //总数
					page_size:4, //一页显示多少
					layout:'total,prev,pager,next'
				},
				allTableData:[],
			};
		},
		metaInfo(){
			return{
				title:"搜索结果_" + metatitle,
				meta:[
					{name:'keywords',content:keywords},
					{name:"description",content:description},
					{name:"SiteName",content:SiteName},
					{name:"SiteDomain",content:SiteDomain},
					{name:"SiteIDCode",content:"辽ICP备16006427号-2"},
					{name:"ColumnName",content:"搜索结果"},
					{name:"ColumnDescription",content:"搜索结果"},
					{name:"ColumnKeywords",content:"搜索结果"},
					{name:"ColumnType",content:"搜索结果"}
				]
			}
		},
		created() {
			this.httpPost();
		},
		methods: {
			httpPost() {
				const _this = this;
				this.$http({
					headers:"application/json; charset=utf-8",
					url: "/api/Index/Search",
					data:{
						"name":_this.$route.params.value,
						"city_id":cityId
					},
					success(res){
						_this.allTableData = res.extend.news_list;
						_this.setPaginations();
					}
				})
			},
			setPaginations(){
				const _this = this;
				_this.paginations.total = _this.allTableData.length; //数据的数量
				_this.paginations.page_index = 1; //默认显示第一页
				//显示数据
				_this.searchList = _this.allTableData.filter((item,index) => {
					return index < _this.paginations.page_size;
				})
			},
			handleSizeChange(page_size) {
				const _this = this;
				_this.paginations.page_index = 1; //第一页
				_this.paginations.page_size = page_size; //每页先显示多少数据
				_this.searchList = _this.allTableData.filter((item,index) => {
					return index < page_size
				})
			},
			handleCurrentChange(page){
				// 跳转页数
				//获取当前页
				const _this = this;
				let index = _this.paginations.page_size * (page -1);
				//获取总数
				let allData = _this.paginations.page_size * page;
				
				let tablist=[];
				for(let i = index;i<allData;i++) {
					if (_this.allTableData[i]) {
						tablist.push(_this.allTableData[i])
					}
					_this.searchList = tablist
				}
			},
			details(id){
				let blank = this.$router.resolve({
					path: '/list/details/' + id,
				});
				window.open(blank.href,'_blank')
			},

		},
	};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/search/search.vue